import { taxes as TaxesApi } from '@teem/constants/api';
import { getAcronym } from '@teem/helpers/functions';
import * as moment from 'moment';


export class OutputTaxTableSchema {
	serverUrl: string = `${TaxesApi.output_taxes}`;
	userInfo: any = (window as any).userInfo;
	containerContext: any;
	headers: Array<object> = [
		{ "label": $localize`:@@ts.invoice_number:Invoice No.`, "thClass": "th-number" },
		{ "label": $localize`:@@ts.date:Date`, "thClass": "th-date" },
		{ "label": $localize`:@@ts.client:Client`, "thClass": "th-client" },
		{ "label": $localize`:@@ts.expenses.total_amount:Total Amount`, "thClass": "th-amount" },
		{ "label": $localize`:@@ts.expenses.taxable_invoice_amount:Taxable Invoice`, "thClass": "th-amount" },
		{ "label": $localize`:@@ts.expenses.vat_rate:VAT Rate`, "thClass": "th-net-vat" },
		{ "label": $localize`:@@ts.expenses.net_vat_amount:Net VAT Amount`, "thClass": "th-amount" },
		{ "label": "", "thClass": "th-editdelete" }
	];

	cols: Array<object> = [
		{ "key": "invoice_number", "tdClass": "td-number" },
		{
			"key": "invoice_date", "tdClass": "td-date",
			"render": (value) => {
				let d = moment(value);
				if (d.isValid()) {
					return (
						`<div class="date">
								<span class="day">${d.format('DD')}</span>
								<span class="month">${d.format('MMM')}</span>
								<span class="year">${d.format('YYYY')}</span>
						</div>`);
				}

				return '';
			}
		},
		{ "key": "client_name", "tdClass": "td-client-name" },
		// { "key": "title", "tdClass": "td-project-name" },
		{
			"key": "total_amount",
			"tdClass": "td-amount", 
			"render": (value, row) => { 
				let currency = row.currency ? row.currency : this.userInfo.currency_symbol;
				return `<span class="bt-content">
							<div class="amount">
								<span class="sar">${currency}</span>
								<span class="price">${value ? parseFloat(value).toFixed(2) : 0}</span>								
							</div>
						</span>`
				// return this.containerContext.currencyPipe.transform(value ? value : 0) 
			}
		},
		{
			"key": "taxable_amount",
			"tdClass": "td-amount", 
			"render": (value, row) => { 
				let currency = row.currency ? row.currency : this.userInfo.currency_symbol;
				return `<span class="bt-content">
							<div class="amount">
								<span class="sar">${currency}</span>
								<span class="price">${value ? parseFloat(value).toFixed(2) : 0}</span>
							</div>
						</span>`
				// return this.containerContext.currencyPipe.transform(value ? value : 0) 
			}
		},
		{
			"key": "tax_percent",
			"tdClass": "td-net-vat", "render": (value) => { return this.containerContext.decimalPipe.transform(value ? value : 0 , '.2') + `%` }
		},
		{
			"key": "net_vat_amount_percent",
			"tdClass": "td-amount", 
			"render": (value, row) => { 
				let currency = row.currency ? row.currency : this.userInfo.currency_symbol;
				return `<span class="bt-content">
							<div class="amount">
								<span class="sar">${currency}</span>
								<span class="price">${value ? parseFloat(value).toFixed(2) : 0}</span>								
							</div>
						</span>`
				// return this.containerContext.currencyPipe.transform(value ? value : 0) 
			}
		},
		{
			"key": "",
			"tdClass": "td-editdelete"
		}
	];

	constructor(container: any) {
		this.containerContext = container;
	}
}